import { getCookie } from "cookies-next"
import { CookieNameEnum } from "../constants/cookie-names"
import Merchant from "../interfaces/merchant/merchant"

/** Obtém valores formatados de data/hora informados no padrão ISO. `2024-12-05T12:48:57.912` */
export class DateHelper {
    public static getDateWithTimezone(isoDate: string) {
        const merchantCookie = getCookie(CookieNameEnum.MerchantSummary)
        const merchant = merchantCookie ? JSON.parse(merchantCookie) as Merchant.ResponseSummary : undefined
        const defaultTzValue = 3

        let merchantTimezone = -defaultTzValue

        if (merchant?.timeZone)
            merchantTimezone = merchant.timeZone

        merchantTimezone += defaultTzValue

        const date = new Date(isoDate)

        // Converte para UTC removendo o offset local.
        const utcMilliseconds = date.getTime() - (date.getTimezoneOffset() * 60 * 1000)

        const targetDate = new Date(utcMilliseconds + (merchantTimezone * 60 * 60 * 1000))
        return targetDate
    }

    public static getUtcDate(date: string) {
        const localDate = new Date(date)
        return new Date(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate())
    }

    /** @returns dd/mm/aaaa */
    public static dateToDayMonthYear(date: string): string {
        return this.getDateWithTimezone(date).toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            timeZone: 'UTC'
        })
    }

    /** @returns 00h00 */
    public static time(date: string): string {
        const targetDate = this.getDateWithTimezone(date)
        const hours = targetDate.getUTCHours().toString().padStart(2, '0')
        const minutes = targetDate.getUTCMinutes().toString().padStart(2, '0')
        return `${hours}h${minutes}`
    }

    /** @returns dd/mm */
    public static dateToDayMonth(date: string): string {
        return this.getDateWithTimezone(date).toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            timeZone: 'UTC'
        })
    }

    /** @returns dd/mm/aaaa 00h00 */
    public static dateTime(date: string): string {
        const dayMonthYear = this.dateToDayMonthYear(date)
        const time = this.time(date)
        return `${dayMonthYear} ${time}`
    }

    /** @returns dd */
    public static day(date: string): string {
        return this.getDateWithTimezone(date).toLocaleDateString('pt-BR', {
            day: '2-digit',
            timeZone: 'UTC'
        })
    }
}